import React, { useContext } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { Empty, Table } from '../../components'
import { LotContext } from './LotContext'
import { getLotDevicesValues, lotTableColumns } from './utils'
import { DeviceTypeEnum } from '../../data/enums'

export const LotDevices = () => {
    const lotContext = useContext(LotContext)
    const { showStationEnabling } = useFlags()
    const columns = showStationEnabling ? lotTableColumns : lotTableColumns.filter((column) => column.key !== 'enabled')
    // const sortedStations = [...(lotContext?.lotStations?.station || [])].sort((a, b) =>
    //     a.station_name.localeCompare(b.station_name)
    // )
    const sortedStations = [...(lotContext?.lotStations?.station || [])]
        .filter((station) => station.type === DeviceTypeEnum.SCANNER)
        .sort((a, b) => {
            const numberA = parseInt(a.station_name?.split('_')?.[1], 10)
            const numberB = parseInt(b.station_name?.split('_')?.[1], 10)
            return numberA - numberB
        })

    const convertedData = sortedStations.map((station) =>
        getLotDevicesValues(station, () => {
            lotContext.setEditingStation(station)
        })
    )
    if (!lotContext.selectedLot) {
        return <Empty title="Select a lot first!" />
    }
    return (
        <div>
            <Table columns={columns} data={convertedData} />
        </div>
    )
}
